import { jsx } from "react/jsx-runtime";
import { useContext, createContext } from "react";
import { useConversationState } from "./hooks/useConversationState.js";
const ConciergeContext = createContext(void 0);
const useConciergeContext = () => {
  const context = useContext(ConciergeContext);
  if (!context) {
    throw new Error("useConciergeContext must be used within ConciergeContextProvider");
  }
  return context;
};
const ConciergeContextProvider = ({
  children,
  apiBaseUrl,
  isSignedIn,
  retailerIdToNameMap,
  inlineSignIn,
  inlineVerifyOtp
}) => {
  const conversationState = useConversationState();
  return /* @__PURE__ */ jsx(ConciergeContext.Provider, { value: { ...conversationState, apiBaseUrl, isSignedIn, retailerIdToNameMap, inlineSignIn, inlineVerifyOtp }, children });
};
export {
  ConciergeContextProvider,
  useConciergeContext
};
//# sourceMappingURL=ConciergeContextProvider.js.map
